import { useCallback } from "react";

import { type CreateGamificationFormData } from "../../validations/gamification.validation";
import { type SubmitOptions } from "./useFormSubmit";

interface UseSubmitAndClearDraftArgs {
  onSubmit: (
    data: CreateGamificationFormData,
    options?: SubmitOptions,
  ) => Promise<boolean>;
  clearDraft: () => void;
}

export function useSubmitAndClearDraft({
  onSubmit,
  clearDraft,
}: UseSubmitAndClearDraftArgs): (
  data: CreateGamificationFormData,
  options?: SubmitOptions,
) => Promise<void> {
  return useCallback(
    async (
      data: CreateGamificationFormData,
      options?: SubmitOptions,
    ): Promise<void> => {
      const created: boolean = await onSubmit(data, options);
      if (created) clearDraft();
    },
    [onSubmit, clearDraft],
  );
}
